/** URL de incorporação do vídeo do YouTube; aceita os formatos watch?v=, youtu.be/, embed/ e shorts/. */
export const youtubeEmbedUrl = (url: string | undefined): string | null => {
    if (!url) return null;
    const match = url.match(/(?:youtube\.com\/(?:watch\?(?:.*&)?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/i);
    return match ? `https://www.youtube.com/embed/${match[1]}` : null;
};
